import { render, staticRenderFns } from "./WasteStreamOption.vue?vue&type=template&id=2f15664e&scoped=true&"
import script from "./WasteStreamOption.vue?vue&type=script&lang=js&"
export * from "./WasteStreamOption.vue?vue&type=script&lang=js&"
import style0 from "./WasteStreamOption.vue?vue&type=style&index=0&id=2f15664e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f15664e",
  null
  
)

export default component.exports